import {Injectable} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {Observable} from "rxjs";
import {DataTablesResponse} from "../models/dataTables-response";
import {webServiceConfig} from "../config/web-service.config";
import {map} from "rxjs/operators";

@Injectable({
  providedIn: 'root'
})
export class SubscriptionsService {

  constructor(private http: HttpClient) {
  }

  datatable(dataTablesParameters): Observable<any> {
      return this.http.post<DataTablesResponse>(`${webServiceConfig.webServiceUrl}subscriptions/datatable`, dataTablesParameters, {})
          .pipe(map(response => {
              return response;
          }));
  }

}
